module.exports = __webpack_public_path__ + "img/image@2x.a8341bdb.png";